<!--
 * @Author: 朱占伟
 * @LastEditors: 朱占伟
 * @description: 提示信息组件
 * @Date: 2021-09-07 14:08:53
 * @LastEditTime: 2021-09-08 11:45:48
-->
<template>
  <div class="sign flex align-center justify-between">
    <i class="iconfont icon-zhuyaotishi ml-10 text-sm" />
    <span class="text-width"> <slot />.</span>
    <van-icon name="arrow" class="mr-10 text-sm arror-icon" @click="trigger" />
  </div>
</template>

<script>

export default {
  props: {
    config: {
      type: Object,
      default: () => {
        return {
          eventName: 'callback',
        };
      }
    }
  }, 
  setup(props,{emit}){
    // 触发事件
    const trigger = (val) => {
      emit(props.config.eventName, val);
    };

    return {
      trigger
    }

  }
}

</script>
<style lang="scss" scoped>
.sign{
  background: #F1F1FF;
  width: 100%;
  height: 38px;
  font-size: 12px;

}
.text-width{
  display: inline-block;
  max-width: 86%;
  white-space: nowrap;
  overflow: auto;

  .text-action{
    color: #6153FF!important;
  }

}
</style>